import { Directive, OnInit, OnDestroy, Injectable, Inject, forwardRef, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import {  WettbewerberDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
  selector: '[wettbewerberDataBinding]'
})
export class WettbewerberDataDirective extends ODataBindingDirective  {

  @Input('wettbewerberDataBinding') query:  ODataEntitySetResource<any>;
    
    constructor(@Inject(forwardRef(() =>WettbewerberDataService)) dataService: WettbewerberDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "Base-Query:", this.query);
        this.rebind();
    }

}
